import { createStore } from "./store-factory";

export interface UIStore {
  // State
  sideNavigationOpen: boolean;
  // Actions
  setSideNavigationOpen: (open: boolean) => void;
}

/**
 * UI Store - Common UI state like side navigation
 * Persisted in sessionStorage (cleared when browser closes)
 * Only essential UI state is persisted
 */
export const useUIStore = createStore<UIStore>(
  "finSpace",
  (set) => ({
    // State
    sideNavigationOpen: false,

    // Actions
    setSideNavigationOpen: (open: boolean) => set({ sideNavigationOpen: open }),
  }),
  {
    persist: true,
    sessionOnly: true,
    persistKey: "finsSpace_UI",
  }
);
